import React from 'react';

const TermsOfService = () => {
  const lastUpdated = 'May 25, 2026';

  return (
    <div className="min-h-screen text-gray-300 font-sans">
      <div className="container mx-auto px-4 max-w-2xl py-8">
        <main>
          <h1 className="text-3xl font-bold text-white mb-6">Terms of Service</h1>
          <p className="text-lg mb-4">
            <strong>Last Updated:</strong> {lastUpdated}
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance and Eligibility</h2>
            <p className="mb-3">
              By creating an account or using Forza (the “Service”), you agree to these Terms. You must be at least 16 years
              old to use the Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">2. Service Description</h2>
            <p className="mb-3">
              Forza is a health and fitness platform that creates personalized quests, tracks progress, and provides coaching
              features using user inputs, automated logic, and AI systems. The Service is for wellness and informational
              purposes only and does not provide medical advice.
            </p>
            <p className="mb-3">
              Forza requires AI and speech processing to create and operate its personalized quest, coaching, verification,
              and form-check features. During registration, you must consent to required AI data processing. If you do not
              consent, you cannot create an account or use the Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">3. Health and Safety Disclaimer</h2>
            <p className="mb-3">
              The Service does not replace professional medical advice, diagnosis, or treatment. Always consult a qualified
              health professional before starting any fitness or nutrition program. AI-generated quests, coaching, media,
              and verification feedback may be inaccurate or incomplete. You use the Service at your own risk.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">4. HealthKit (Optional)</h2>
            <p className="mb-3">
              If you enable HealthKit, we read step count, sleep analysis, and active energy burned for the current day to help verify eligible daily quests. You can
              disable HealthKit access at any time in iOS Settings. We do not write data to HealthKit and do not use
              HealthKit data for advertising or tracking.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">5. Accounts and Security</h2>
            <p className="mb-3">
              You are responsible for maintaining the confidentiality of your credentials and for all activity under your
              account. Email verification infrastructure may be present, but Forza does not currently require email
              verification before account access. If you believe your account has been compromised, contact us immediately.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">6. Subscriptions and Purchases</h2>
            <p className="mb-3">
              Ultra on iOS is purchased through Apple In-App Purchase. RevenueCat synchronizes entitlement status with Forza
              so server-side feature access can be updated after purchases, renewals, cancellations, refunds, or restores.
              You can restore purchases and open subscription management from the app. Prices may change with notice where
              required by law.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">7. Rewarded Ads</h2>
            <p className="mb-3">
              The free tier may include optional rewarded ads to unlock limited features. Where legally allowed and only with
              required consent or App Tracking Transparency permission, ads may be personalized. If consent or permission is
              denied, unavailable, or withdrawn, we use non-personalized or limited ads where supported. HealthKit data,
              audio, photos, and sensitive fitness profile details are not used for ad targeting.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">8. AI Data Processing</h2>
            <p className="mb-3">
              To provide the Service, Forza may send your fitness goals, preferences, profile context, onboarding answers,
              quest plans, quest activity, completion status, verification context, submitted text, voice recordings and
              transcripts, photos, exercise frames, and relevant app, device, and diagnostic context to third-party AI,
              speech, hosting, storage, media, monitoring, subscription, advertising consent, reward attribution, and
              security providers.
            </p>
            <p className="mb-3">
              AI and speech providers may include Google, Groq, OpenRouter, DeepSeek, OpenAI, and local or on-device providers
              where available. Forza does not sell your personal data or share it for third-party advertising or profiling.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">9. User Content</h2>
            <p className="mb-3">
              You grant Forza a limited, worldwide, non-exclusive license to process the content you submit (such as audio,
              photos, and text) to provide, secure, verify, operate, and improve the Service. Generated or reported quest media
              may be reviewed by an admin and removed if it is unreliable.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">10. Prohibited Use</h2>
            <p className="mb-3">
              You agree not to misuse the Service, attempt unauthorized access, or use the Service in a way that violates any
              laws or infringes the rights of others.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">11. Termination and Account Deletion</h2>
            <p className="mb-3">
              You may delete your account in Settings. Upon deletion, your account data is anonymized and HealthKit snapshots
              are removed. Anonymized logs may be retained for up to 12 months for audit and fraud prevention.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">12. Limitation of Liability</h2>
            <p className="mb-3">
              To the maximum extent permitted by law, Forza and its operator are not liable for any indirect, incidental,
              special, or consequential damages arising from your use of the Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">13. Governing Law</h2>
            <p className="mb-3">
              These Terms are governed by the laws of Spain. The courts of Barcelona, Spain, shall have exclusive jurisdiction
              over any disputes arising from these Terms or the Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">14. Contact</h2>
            <p className="mb-3">
              For questions about these Terms, contact Matteo Fabbri at matteo.fbr@gmail.com or by mail at Carrer de Bergara,
              7, 08002 Barcelona, Spain.
            </p>
          </section>
        </main>
      </div>
    </div>
  );
};

export default TermsOfService;
